import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../config/Config';

const PaytmPost = ({ checkSum, paymentData, payment_type }) => {
	useEffect(() => {
		if (checkSum !== '') {
			const script = document.createElement('script');
			var code = 'document.paymentform.submit();';
			script.async = true;
			script.appendChild(document.createTextNode(code));
			document.body.appendChild(script);
		}
	}, [checkSum]);

	var paramsList = '';
	if (typeof paymentData !== 'undefined') {
		if (localStorage.getItem('payment_type')?.toLowerCase() === 'stripe') {
			paramsList = (
				<input type="hidden" name="ORDER_ID" value={paymentData['ORDER_ID']} />
			);
		} else {
			paramsList = Object.keys(paymentData).map(function (param_key) {
				return (
					<input type="hidden" name={param_key} value={paymentData[param_key]} />
				);
			});
		}
	}
	return (
		<div>
			{
				<form
					method="post"
					action={
						localStorage.getItem('payment_type')?.toLowerCase() === 'stripe'
							? `${paymentData['postUrl']}`
							: `${Config.PAYTMURL}`
					}
					name="paymentform"
				>
					{paramsList}
					<input type="hidden" name="CHECKSUMHASH" value={checkSum} />
				</form>
			}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { checkSum, paymentData } = state.rootReducer.buyCourse;
	return {
		checkSum,
		paymentData,
	};
};

export default connect(mapStateToProps)(PaytmPost);
